import type { CompetencyAssignmentSortBy } from "../../../../../api/services/defs/competency-assignments";

export const PAGE_SIZE = 25;

export const colIdToSortBy = (colId: string | undefined): CompetencyAssignmentSortBy | null => {
	if (colId === "competency_name" || colId === "expected_level" || colId === "current_level") return colId;
	return null;
};
